import React, { useMemo, useState } from "react";
import { Inbox, LayoutGrid, BookOpen, Users2 } from "lucide-react";
import AnaInboxPanel from "./AnaInboxPanel";
import AnaPipelinePanel from "./AnaPipelinePanel";
import AnaLibraryPanel from "./AnaLibraryPanel";

// V1.31 · Workspace de ANA. Agrupa todas las herramientas del agente comercial.
const SECTIONS = [
  { key: "bandeja",    label: "Bandeja",    icon: Inbox,       component: AnaInboxPanel },
  { key: "pipeline",   label: "Pipeline",   icon: LayoutGrid,  component: AnaPipelinePanel },
  { key: "biblioteca", label: "Biblioteca", icon: BookOpen,    component: AnaLibraryPanel },
];

export default function AnaWorkspace({ initialSection }) {
  const [section, setSection] = useState(initialSection || "bandeja");
  const Active = useMemo(
    () => (SECTIONS.find((s) => s.key === section) || SECTIONS[0]).component,
    [section]
  );

  return (
    <div className="space-y-4" data-testid="ana-workspace">
      {/* Header workspace */}
      <div className="rounded-2xl border-2 border-sky-200 bg-gradient-to-br from-sky-50 to-cyan-50 p-4">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-sky-500 text-white flex items-center justify-center shadow-sm">
            <Users2 className="h-5 w-5" />
          </div>
          <div>
            <div className="text-lg font-bold text-neutral-900">ANA · Agente Comercial</div>
            <div className="text-xs text-neutral-600">CRM, pipeline de ventas, bandeja del día y plantillas comerciales.</div>
          </div>
        </div>
      </div>

      {/* Sub-nav horizontal */}
      <div className="card-surface p-1 flex flex-wrap gap-1" data-testid="ana-workspace-subnav">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          const active = s.key === section;
          return (
            <button
              key={s.key}
              onClick={() => setSection(s.key)}
              data-testid={`ana-subnav-${s.key}`}
              className={
                "inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors " +
                (active
                  ? "bg-sky-500 text-white shadow-sm"
                  : "text-neutral-700 hover:bg-sky-50")
              }
            >
              <Icon className="h-4 w-4" />
              <span>{s.label}</span>
            </button>
          );
        })}
      </div>

      {/* Contenido */}
      <div>
        <Active />
      </div>
    </div>
  );
}
